import { render, staticRenderFns } from "./TabLiquidationPrice.vue?vue&type=template&id=516f7e72&scoped=true"
import script from "./TabLiquidationPrice.vue?vue&type=script&lang=js"
export * from "./TabLiquidationPrice.vue?vue&type=script&lang=js"
import style0 from "./TabLiquidationPrice.vue?vue&type=style&index=0&id=516f7e72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516f7e72",
  null
  
)

export default component.exports